export default __webpack_public_path__ + "images/GRUMAIR.e25223f.png";